export default {
  lucky: {
    prizeAgain: 'Pusing Lagi',
    prizeThanks: 'Cuba Lagi',
    remainingChance: 'Baki Pusingan',
    task: 'Tugasan',
    deposit: 'Deposit',
    wager: 'Pertaruhan',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'Koleksi Kad',
    puzzleRound: 'Pusingan {current}/{total}',
    puzzleReward: 'Ganjaran siap {amount}',
    redeem: 'Tebus',
    redeemSuccess: 'Berjaya ditebus',
    redeemSuccessWithReward: 'Berjaya ditebus! Anda menerima {amount} {currency}',
    redeemFailed: 'Gagal menebus',
    notComplete: 'Belum lengkap, tidak boleh ditebus',
    drawFailed: 'Cabutan gagal, sila cuba lagi',
    gainLetter: 'Tahniah! Anda mendapat huruf {letter}',
    gainBlock: 'Tahniah! Anda mendapat gambar {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'Jemput',
    claimReward: 'Tuntut',
    noChest: 'Tiada peti',
    claimSuccess: 'Menuntut {count} peti, {amount} {currency}',
    modalTitle: 'Peti harta',
    modalSubtitle: 'Leret untuk lihat semua',
    chipTodayClaimed: 'Dituntut hari ini',
    chipClaimable: 'Boleh dituntut',
    chipLocked: 'Terkunci',
    totalClaimedCount: 'Jumlah peti dituntut',
    totalClaimedAmount: 'Jumlah dituntut',
    chestUnit: 'pcs',
    claimAll: 'Tuntut semua',
    goInvite: 'Jemput Sekarang',
    claimSingleSuccess: 'Menuntut {amount} {currency}',
    labelClaimed: 'Dituntut',
    labelClaimable: 'Boleh dituntut',
    labelLocked: 'Terkunci',
  },
}
